import React from "react";

import "./previousDayPerfomance.css";
import PredictionBoxCurrent from "../../predictionSection/predictionBoxes/PredictionBoxCurrent";

import ProgressBar from "react-bootstrap/ProgressBar";

import ShareAlt from "../../../assets/img/share-alt.png";
import { useSelector } from "react-redux";

const PreviousDayPerfomance = (prop) => {
    const showPerformanceStats =  localStorage.webKey && prop.scoreProfile
  return (
    <div className="previousDayPerfomace">
      <div className="previousDayPerfomance-wrapper">
        {showPerformanceStats &&
        <div className="previousDayPerfomance-topSection">
          <div className="previousDayPerfomance-title">
            <h4>{prop.day} Perfomance</h4>
          </div>
          <div className="previousDayPerfomance-points-wrapper">
            <div className="previousDayPerfomace-earnedPoints-wrapper">
              <h6 className="point">{prop.scoreProfile?.user_points}</h6>
              <div className="text">
                <p>{prop.day}</p>
                <p>Points</p>
              </div>
            </div>
            <div className="previousDayPerfomace-totalPoints-wrapper">
              <h6 className="point">{prop.scoreProfile?.total_points}</h6>
              <div className="text">
                <p>Total</p>
                <p>Points</p>
              </div>
            </div>
          </div>
          <div className="previousDayPerfomance-stat-wrapper">
            <div className="previousDayPerfomace-statRight-wrapper">
              <h6 className="count">{prop.scoreProfile?.user_won_count}</h6>
              <div className="text">
                <p>Right</p>
                <p>Predictions</p>
              </div>
            </div>
            <div className="previousDayPerfomace-statWrong-wrapper">
                <h6 className="count">{prop.scoreProfile?.user_lost_count}</h6>
              <div className="text">
                <p>Wrong</p>
                <p>Predictions</p>
              </div>
            </div>
            <div className="previousDayPerfomace-statMissed-wrapper">
              <h6 className="count">
                {prop.questions
                  ? parseInt(prop.questions.length) -
                    (parseInt(prop.scoreProfile?.user_lost_count) +
                      parseInt(prop.scoreProfile?.user_won_count))
                  : ""}
              </h6>
              <div className="text">
                <p>Missed</p>
                <p>Predictions</p>
              </div>
            </div>
          </div>
          <div style={{height:10,backgroundColor:'#F3F3F3'}}/>
        </div>}
        <div className="previousDayPerfomance-bottomSection">
          <div className="previousDayPerfomance-bottom-wrapper">
            {prop.questions
              ? prop.questions.map((question, index) =>
                  question.user_prediction ? (
                    question.user_prediction.result != 0 ? (
                      <div className="previousDayPerfomance-bottom-part1">
                        <h6 className="points">
                          +{question.user_prediction.score}
                        </h6>
                        <div className="question-wrapper">
                          <p className="question">
                            {localStorage.language == "en"
                              ? question.question
                              : question.que_malayalam}
                          </p>
                          <p className="answer">
                            {question.user_prediction &&
                            question.user_prediction.result
                              ? localStorage.language == "en"
                                ? "Your prediction " +
                                  question.user_prediction.answer +
                                  " was correct"
                                : "താങ്കളുടെ പ്രവചനം " +
                                  question.user_prediction.answer +
                                  " ശരിയാണ്."
                              : localStorage.language == "en"
                              ? "Your prediction " +
                                question.user_prediction.answer +
                                " was wrong "
                              : " താങ്കളുടെ പ്രവചനം " +
                                question.user_prediction.answer +
                                " തെറ്റായിരുന്നു."}
                          </p>



                          <div className="progress-share-wrapper">
                            <div className="progress-bar-wrapper">
                              <p className="progress-bar-top-text">
                                {question.right_percent}% Predicted the right
                                answer {question?.que_answer}
                              </p>
                              <ProgressBar now={question.right_percent} />
                            </div>

                            {/* <div className="progress-share-img">
                              <img src={ShareAlt} alt="" />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="previousDayPerfomance-bottom-part2">
                        <h6 className="points">
                          +{question.user_prediction.score}
                        </h6>
                        <div className="question-wrapper">
                          <p className="question">
                            {localStorage.language == "en"
                              ? question.question
                              : question.que_malayalam}
                          </p>
                          <p className="answer">
                            {question.user_prediction.result
                              ? localStorage.language == "en"
                                ? "Your prediction " +
                                  question.user_prediction.answer +
                                  " was correct"
                                : "താങ്കളുടെ പ്രവചനം " +
                                  question.user_prediction.answer +
                                  " ശരിയാണ്."
                              : localStorage.language == "en"
                              ? "Your prediction " +
                                question.user_prediction.answer +
                                " was wrong"
                              : "താങ്കളുടെ പ്രവചനം " +
                                question.user_prediction.answer +
                                " തെറ്റായിരുന്നു."}
                          </p>

                          <div className="progress-share-wrapper">
                            <div className="progress-bar-wrapper">
                              <p className="progress-bar-top-text">
                                {question.right_percent}% predicted the right

                                answer {question?.que_answer}
                              </p>
                              <ProgressBar now={question.right_percent} />
                            </div>

                            {/* <div className="progress-share-img">
                              <img src={ShareAlt} alt="" />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <PredictionBoxCurrent
                      key={index}
                      question={question}
                      index={index}
                    />
                  )
                )
              : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviousDayPerfomance;
